import { Link } from 'react-router-dom';
import { productCategories } from '../config/productsMenuConfig';
import './ProductsMegaMenu.css';

const ProductsMegaMenu = ({ open }) => {
  if (!open) return null;

  return (
    <div className="products-mega-menu" role="navigation" aria-label="Products menu">
      <div className="products-mega-inner">
        <div className="products-mega-grid">
          {productCategories.map((cat) => (
            <div key={cat.title} className="products-mega-column">
              <div className="products-mega-cat">
                <span className="products-mega-cat-tag">{cat.tag}</span>
                <span className="products-mega-cat-title">{cat.title}</span>
              </div>
              <ul className="products-mega-list">
                {cat.items.map((it) => (
                  <li key={it.slug}>
                    <Link to={it.href} className="products-mega-link">
                      <span className="products-mega-link-head">
                        <span className="products-mega-name">{it.label}</span>
                        {it.status === 'preview' && (
                          <span className="products-mega-badge">In preview</span>
                        )}
                      </span>
                      <span className="products-mega-desc">{it.menuDesc}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="products-mega-footer">
          <Link to="/products" className="products-mega-view-all">
            View all products →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductsMegaMenu;
